import sliceCreator from '../../index.jsx';
import {UPDATE_TENANT_USER} from '../../../constants/index.jsx';
const _updateTenantUserAction = sliceCreator('UPDATE_TENANT_USER', UPDATE_TENANT_USER, 'put');

const { asyncAction: updateTenantUserAction, reducer, clearData: clearUpdateTenantUserAction } = _updateTenantUserAction;

export default reducer;

export {
    updateTenantUserAction,
    clearUpdateTenantUserAction
}